import { useLocation } from "react-router-dom"

function Dispute({ size = 28 }) {
  const location = useLocation()
  const isActive = location.pathname.startsWith('/dispute-center')
  const color = isActive ? '#FFFFFF' : '#8F9DAC'
  return (
    <svg width={size} height={size} viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.1673 12.4728L14.4087 12.2314C16.7172 9.92286 20.4601 9.92286 22.7686 12.2314C25.0772 14.5399 25.0772 18.2828 22.7686 20.5913L19.4247 23.9352C17.1162 26.2438 13.3733 26.2438 11.0647 23.9352C8.75621 21.6267 8.75621 17.8838 11.0647 15.5753L11.6065 15.0336'
        stroke={color}
        stroke-width='1.8'
        stroke-linecap='round'
      />
      <path
        d='M23.3935 12.9665L23.9352 12.4248C26.2438 10.1163 26.2438 6.37341 23.9352 4.06488C21.6267 1.75637 17.8838 1.75637 15.5753 4.06488L12.2314 7.40885C9.92287 9.71737 9.92287 13.4602 12.2314 15.7687C14.5399 18.0773 18.2828 18.0773 20.5913 15.7687L20.8327 15.5273'
        stroke={color}
        stroke-width='1.8'
        stroke-linecap='round'
      />
      <path
        d='M5.24999 4.6665L6.99999 6.99984M2.33333 9.33317L5.83333 10.4998M3.49999 15.7498L5.83333 13.9998'
        stroke={color}
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}
export default Dispute
